import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DeviceTitle from './DeviceTitle';
import DeviceLists from './DeviceLists';
import UpdateDeviceDialog from './UpdateDeviceDialog';
import updateDevice from '../../actions/api/device/updateDevice';
import config from '../../config';

const MainBlock = styled.div`
  flex: 1 0 auto;
  width: 100%;
  height: 100%;
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`;
const BodyBlock = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const DeviceListsWrapper = styled.div`
  width: 100%;
  height: calc(100% - 50px);
  @media (max-height: 530px) {
    height: calc(100% - 30px);
  }
`;
const { updateDeviceNickname } = config.customRole.functionAccess;

/**
 * デバイス管理画面
 *
 * @param {Function} dispatch - Redux Dispatch関数
 * @param {number} role - ユーザーの権限
 * @param {string} apiToken - APIトークン
 * @param {Array} devices - デバイス情報の配列
 * @param {boolean} openUpdateDeviceDialog - デバイス情報更新ダイアログを開くかどうか
 * @param {Object} confirmData
 * @param {Object} confirmDataError
 * @param {Function} onClose
 */
const DevicePage = ({
  dispatch,
  role,
  apiToken,
  devices,
  openUpdateDeviceDialog,
  confirmData,
  confirmDataError,
  onClose,
}) => {
  const displayUpdateButton = updateDeviceNickname.indexOf(role) !== -1;
  return (
    <MainBlock className="devicePage">
      <BodyBlock>
        <DeviceTitle />
        <DeviceListsWrapper>
          <DeviceLists
            devices={devices}
            onSelect={deviceId => {
              dispatch({ type: 'OPEN_UPDATE_DEVICE_DIALOG', deviceId });
            }}
          />
        </DeviceListsWrapper>
        {openUpdateDeviceDialog && (
          <UpdateDeviceDialog
            confirmData={confirmData}
            confirmDataError={confirmDataError}
            onClose={onClose}
            onUpdate={params => {
              dispatch(updateDevice(apiToken, params));
              onClose();
            }}
            onUpdateConfirm={updateParam => {
              dispatch({ type: 'UPDATE_DEVICE_CONFIRM', updateParam });
            }}
            displayUpdateButton={displayUpdateButton}
          />
        )}
      </BodyBlock>
    </MainBlock>
  );
};

DevicePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  role: PropTypes.number.isRequired,
  apiToken: PropTypes.string.isRequired,
  devices: PropTypes.array.isRequired,
  openUpdateDeviceDialog: PropTypes.bool.isRequired,
  confirmData: PropTypes.object.isRequired,
  confirmDataError: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DevicePage;
